import { Icon } from '@/components/Icon';
import { logError } from '@/utils/logHandling';
import { Linking, Pressable, View } from 'react-native';
import { Text } from '@/components/Text';

export const Kontakt = () => {
  const handleEmailPress = async () => {
    try {
      await Linking.openURL('mailto:info@neolexon.de');
    } catch (error) {
      logError('Error opening email:', error);
    }
  };

  const handlePhonePress = async () => {
    try {
      await Linking.openURL('tel:+49 (0)89 24886 4440');
    } catch (error) {
      logError('Error opening email:', error);
    }
  };

  return (
    <View className="w-full p-4">
      <View className="w-full mb-4">
        <Text className="text-2xl text-center font-semibold text-slate-700">
          Verfügbarkeit: Mo-Fr 08:00 - 15:00 Uhr
        </Text>
      </View>
      <View className="flex-row justify-center w-full">
        <Pressable
          className="p-2 rounded-md bg-slate-100 mr-2"
          onPress={handleEmailPress}
        >
          <View className="flex-row items-center">
            <Icon
              className="text-3xl text-green-neolexon mr-1"
              name={'envelope'}
            />
            <Text className="text-2xl">info@neolexon.de</Text>
          </View>
        </Pressable>
        <Pressable
          className="p-2 rounded-md bg-slate-100"
          onPress={handlePhonePress}
        >
          <View className="flex-row items-center">
            <Icon className="text-3xl text-green-neolexon mr-1" name="phone" />
            <Text className="text-2xl">+49 (0)89 24886 4440</Text>
          </View>
        </Pressable>
      </View>
    </View>
  );
};
